<script setup lang="ts">
import {DosageFrequency} from "@/dosage/interfaces/Dosage";
import useDosageFrequencies from "@/dosage/composables/useDosageFrequencies";
import DosageOptionChip from "@/dosage/components/DosageOptionChip.vue";
import DosageDatesSelect from "@/dosage/components/DosageDatesSelect.vue";
import {DosageFormData} from "@/dosage/interfaces/DosageForm";

defineProps<{
    hideCustomFrequency?: boolean;
    frequencyError?: string | null;
    datesError?: string | null;
}>();

const frequency = defineModel<DosageFrequency | null>("frequency", {required: true});
const dates = defineModel<DosageFormData['dates'] | null>("dates", {required: true});

const {data} = useDosageFrequencies();
const toggleSelection = (_frequency: DosageFrequency) => {
    frequency.value = frequency.value?.id === _frequency.id ? null : _frequency;
};

const toggleDate = (date: { id?: number; value: Date }) => {
    if (!dates.value) {
        return;
    }

    const index = dates.value.findIndex(_date => {
        if (_date.id && date.id) return _date.id === date.id;
        return _date.value.getTime() === date.value.getTime();
    });

    if (index !== -1) {
        dates.value.splice(index, 1);
    }
};
</script>

<template>
  <div class="space-y-2">
    <p class="text-xs font-medium text-gray-500">
      Fréquence
    </p>
    <div v-if="!hideCustomFrequency" class="flex items-center gap-1.5 flex-wrap">
      <DosageDatesSelect v-model:model-value="dates" />
    </div>
    <div class="flex gap-x-2 gap-y-3 flex-wrap">
      <template v-if="!dates?.length">
        <DosageOptionChip
          v-for="item in (data ?? [])"
          :key="item.id"
          :selected="frequency?.id === item.id"
          @click="toggleSelection(item)"
        >
          {{ item.name }}
        </DosageOptionChip>
      </template>
      <template v-else>
        <DosageOptionChip
          v-for="(date, index) in dates"
          :key="index"
          selected
          @click="toggleDate(date)"
        >
          {{ new Intl.DateTimeFormat('fr-FR', {weekday: 'long', month: 'short', day: 'numeric'}).format(date.value) }}
        </DosageOptionChip>
      </template>
    </div>
    <p v-if="frequencyError" class="text-xs text-red-500">
      {{ frequencyError }}
    </p>
    <p v-if="datesError" class="text-xs text-red-500">
      {{ datesError }}
    </p>
  </div>
</template>
